import { Description as DescriptionIcon, Assignment as AssignmentIcon } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

import type { ToggleViewType } from '@/apps/engagement-letter-database/data/types';

interface PageHeaderProps {
  value: ToggleViewType | 'waiver';
}

const labels = {
  waiver: 'Waiver',
  'related-clients': 'Related Clients',
  clients: 'Clients',
} as const;

const PageHeader = ({ value }: PageHeaderProps) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {value === 'related-clients' ? (
        <DescriptionIcon sx={{ mr: 1, fontSize: 32, color: 'primary.main' }} />
      ) : (
        <AssignmentIcon sx={{ mr: 1, fontSize: 32, color: 'secondary.main' }} />
      )}
      <Typography variant="h4">Search {labels[value]} Letters</Typography>
    </Box>
  );
};

export default PageHeader;
